import { useState } from 'react'

import { EMPTY_STRING } from '../../../../constants/common'

import {
  getCalendarSettingsVisibleTaskTypes,
  getHasCalendarSettingsTaskTypesSearch,
  getIsCalendarSettingsTaskTypesEmpty,
} from './TaskTypesField.utils'
import { TaskTypesFieldEmpty } from './TaskTypesFieldEmpty'
import { TaskTypesFieldList } from './TaskTypesFieldList'
import { TaskTypesFieldSearch } from './TaskTypesFieldSearch'

import * as styles from './TaskTypesField.module.css'

function TaskTypesField({ taskTypes }) {
  const [search, setSearch] = useState(EMPTY_STRING)

  const hasSearch = getHasCalendarSettingsTaskTypesSearch(taskTypes)

  function handleChangeSearch(event) {
    setSearch(event.target.value)
  }

  return getIsCalendarSettingsTaskTypesEmpty(taskTypes) ? (
    <TaskTypesFieldEmpty />
  ) : (
    <div className={styles.TaskTypesField}>
      {hasSearch ? (
        <TaskTypesFieldSearch value={search} onChange={handleChangeSearch} />
      ) : null}
      <TaskTypesFieldList
        isScrollable={hasSearch}
        taskTypes={getCalendarSettingsVisibleTaskTypes({ search, taskTypes })}
      />
    </div>
  )
}

export default TaskTypesField
